import React from 'react';
import { Tile, TileContextProvider } from '@fmc-digital/ui';
type TeaserOfferProps = {
    logUserEvent: (event: any) => void;
    onDeepLink: (offer: any) => void;
    key: string;
    offerTemplate: any;
};

export const TeaserOffer: React.FC<TeaserOfferProps> = (props: TeaserOfferProps) => {
    const { logUserEvent, onDeepLink, key, offerTemplate } = props;
    return (
        <TileContextProvider onDeepLink={onDeepLink} logUserEvent={logUserEvent} key={key} {...offerTemplate}>
            <Tile key={`teaser_template_tile`} />
        </TileContextProvider>
    );
};
